import axios from 'axios'

const service = axios.create({
    baseURL: process.env.VUE_APP_URL, // url = base url + request url
    timeout: 50000, // request timeout
    headers: {
      'dapr-app-id': 'backend'
    }
})

service.interceptors.request.use(
    config => {
      // do something before request is sent
      var token = localStorage.getItem("token")
      if(token){
        var token_type = localStorage.getItem("token_type")
        var auth = token_type + " " + token
        config.headers["Authorization"] = auth
        config.headers["Version"] = localStorage.getItem("backend_version")
      }
      return config
    },
    error => {
      // do something with request error
      console.log(error) // for debug
      return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */
  
    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
      // return response.data
      // const res = response.data
      if (response.data.code == 420){
        localStorage.removeItem("token") 
        location.reload()
      }
      return response.data
  
      // if (response.data.status !== 200) {
      //   Message({
      //     message: response.data.msg || 'Error',
      //     type: 'error',
      //     duration: 5 * 1000
      //   })
      //   return Promise.reject(new Error(response.data.msg || 'Error'))
      // } else {
      //   return response.data
      // }
  
      // if the custom code is not 20000, it is judged as an error.
      // if (res.code !== 20000) {
      //   Message({
      //     message: res.message || 'Error',
      //     type: 'error',
      //     duration: 5 * 1000
      //   })
      //
      //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //     // to re-login
      //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //       confirmButtonText: 'Re-Login',
      //       cancelButtonText: 'Cancel',
      //       type: 'warning'
      //     }).then(() => {
      //       store.dispatch('user/resetToken').then(() => {
      //         location.reload()
      //       })
      //     })
      //   }
      //   return Promise.reject(new Error(res.message || 'Error'))
      // } else {
      //   return res
      // }
    },
    error => {
      console.log('err' + error) // for debug
      return Promise.reject(error)
    }
)

export default service